export const CALYPSO = "#00a4bd";
export const CALYPSO_DARK = "#0091ae";
export const CALYPSO_MEDIUM = "#7fd1de";
export const CALYPSO_LIGHT = "#e5f5f8";
export const SORBET = "#ff8f59";
export const SORBET_DARK = "#e68250";
export const SORBET_MEDIUM = "#ffc7ac";
export const SORBET_LIGHT = "#fff3ee";
export const LORAX = "#ff7a59";
export const LORAX_DARK = "#e66e50";
export const LORAX_MEDIUM = "#ffbcac";
export const LORAX_LIGHT = "#fff1ee";
export const MARIGOLD = "#f5c26b";
export const MARIGOLD_DARK = "#dbae60";
export const MARIGOLD_MEDIUM = "#fae0b5";
export const MARIGOLD_LIGHT = "#fef8f0";
export const CANDY_APPLE = "#f2545b";
export const CANDY_APPLE_DARK = "#d94c53";
export const CANDY_APPLE_MEDIUM = "#f8a9ad";
export const CANDY_APPLE_LIGHT = "#fdedee";
export const NORMAN = "#f2547d";
export const NORMAN_DARK = "#d94c71";
export const NORMAN_MEDIUM = "#f9aabe";
export const NORMAN_LIGHT = "#fdedf2";
export const THUNDERDOME = "#6a78d1";
export const THUNDERDOME_DARK = "#5e6ab8";
export const THUNDERDOME_MEDIUM = "#b4bbe8";
export const THUNDERDOME_LIGHT = "#f0f1fa";
export const OZ = "#00bda5";
export const OZ_DARK = "#00a38d";
export const OZ_MEDIUM = "#7fded2";
export const OZ_LIGHT = "#e5f8f6";
export const FLAT_EARTH = "#253342";
export const PANTERA = "#2d3e50";
export const OBSIDIAN = "#33475b";
export const HEFFALUMP = "#425b76";
export const SLINKY = "#516f90";
export const EERIE = "#7c98b6";
export const FLINT = "#99acc2";
export const BATTLESHIP = "#cbd6e2";
export const GREAT_WHITE = "#dfe3eb";
export const KOALA = "#eaf0f6";
export const CIRRUS = "#f2f5f8";
export const GYPSUM = "#f5f8fa";
export const OLAF = "#ffffff";
export const MONOLITH = "#000000";
export const CHART_RED = "#ea90b1";
export const CHART_ORANGE = "#fea58e";
export const CHART_YELLOW = "#f5c78e";
export const CHART_GREEN = "#a2d28f";
export const CHART_AQUA = "#51d3d9";
export const CHART_BLUE = "#81c1fd";
export const CHART_PURPLE = "#bda9ea";
export const CHART_DARK_PURPLE = "#9784c2";
export const LINK_HOVER = "#007a8c";
export const BUTTON_PRIMARY_HOVER_FILL = "#ff8f73";
export const BUTTON_SECONDARY_TEXT = "#ff7a53";
export const BUTTON_SECONDARY_HOVER_FILL = "#fff8f6";
export const BUTTON_SECONDARY_ACTIVE_FILL = "#ffebe6";
export const BUTTON_TERTIARY_LIGHT_TEXT = "#506e91";
export const BUTTON_TERTIARY_LIGHT_HOVER_FILL = "#e5eaf0";
export const BUTTON_DANGER_HOVER_FILL = "#ff5962";
export const BUTTON_DISABLED_TEXT = "#b0c1d4";
export const FOCUS_RING_BASE = "#00d0e4";
export const ALERT_DANGER = "#f04b51";
export const ALERT_WARNING = "#fdf3e1";
export const ALERT_SUCCESS = "#5967bc";
export const LINKEDIN = "#0077b5";
export const TWITTER = "#55acee";
export const FACEBOOK = "#3b5998";
export const GOOGLE = "#dd4b39";
export const XING = "#026466";
export const PINTEREST = "#bd081c";
export const RSS = "#f26522";
export const YOUTUBE = "#ff0000";
export const INSTAGRAM = "#c13584";
export const TRANSPARENT_DARK = "rgba(0, 0, 0, 0)";
export const TRANSPARENT_LIGHT = "rgba(255, 255, 255, 0)";
export const TRANSPARENT = "rgba(0, 0, 0, 0)";
